import type { ResultEvent } from '../../../types/events';
import type { Follow } from '../../../types/following';

/**
 * Gathers all of the followed resultCodes across all subevents in an event into a single array
 * @param following - Follow[]
 * @returns
 */
export const getAllFollowsForEvent = (following: Follow[], event?: ResultEvent): Follow[] =>
  // NOTE: We MUST use the subEvent ids here because the BFF filters out sub events that the user doesn't currently
  // have access too. For example, the user was a timer and was logged in while following people. Some of those people
  // were in races marked `private`. Then the timer logs out...we essentially have to ignore those follows for the
  // private races
  following
    .filter((follow) => event?.subEvents?.find((subEvent) => subEvent.id === follow.subEventId))
    .concat(following.filter((follow) => follow.eventId === event?.id && follow.subEventId === 0)); // NOTE: this is for follows from the URL until their subEventId gets set
